import React from 'react'
import { useTranslation } from 'react-i18next'

import ContentTranslations from 'components/ContentTranslations'

const ContentTranslationsPage = ({ id, itemId, data }) => {
	const [t] = useTranslation()
	return (<ContentTranslations id={itemId} translationTypes={[{
		type: 'CATEGORY',
		label: t('common.fields.name'),
		value: data.name
	}]}/>)
}

export default ContentTranslationsPage
